export const alertActions = {};

// Utility functions to interact with the registry
export const addActionToRegistry = (id, action) => {
  alertActions[id] = action;
};

export const removeActionFromRegistry = (id) => {
  delete alertActions[id];
};

export const getActionFromRegistry = (id) => {
  return alertActions[id];
};
